import { render, staticRenderFns } from "./separator.vue?vue&type=template&id=574ca850&"
import script from "./separator.vue?vue&type=script&lang=js&"
export * from "./separator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports